// extracted by mini-css-extract-plugin
export default {"admin__content_main":"AdminLayout_admin__content_main__+C1I5","admin__wrapper_content":"AdminLayout_admin__wrapper_content__Z6bxp"};